<script>
  import { onMount } from "svelte";
  import Chip, { Checkmark, Text } from '@smui/chips';
  import util from './const';

  export let data;
</script>

<style>
</style>

<div>
    {#if data}
    <p>
        <span><strong>Service:</strong> {util.getLabel(data.service_style, util.serviceStyleOpts)}</span>
        <br />
        <span><strong>Menu:</strong> {util.getLabel(data.menu_type, util.menuTypeOpts)}</span>
    </p>
    <p>
        <strong>Mains:</strong>
        <Chip selected={data.meat_main_reqd}><Checkmark /><Text>Meat</Text></Chip>
        <Chip selected={data.fish_main_reqd}><Checkmark /><Text>Fish</Text></Chip>
        <Chip selected={data.veg_main_reqd}><Checkmark /><Text>Vegetarian</Text></Chip>
    </p>
    <p>
        <strong>Extras:</strong>
        <Chip selected={data.bread_reqd}><Checkmark /><Text>Bread</Text></Chip>
        <Chip selected={data.side_reqd}><Checkmark /><Text>Side</Text></Chip>
        <Chip selected={data.dessert_reqd}><Checkmark /><Text>Dessert</Text></Chip>
    </p>
    <p>
        <span>
        <strong>Dietry:</strong>
        <strong>{data.dr_num_vegetarian}</strong> Vegetarian,
        <strong>{data.dr_num_vegan}</strong> Vegan,
        <strong>{data.dr_num_gluten_free}</strong> GF
        </span>
        <br/>
        <span>
        <strong>Allergies:</strong>
        <strong>{data.dr_num_nut_allergies}</strong> Nuts,
        <strong>{data.dr_num_dairy_allergies}</strong> Dairy,
        <strong>{data.dr_num_other_allergies}</strong> Other
       </span>
    </p>
    <p>
        <span><strong>Consumables:</strong> {util.getLabel(data.consumables_required, util.consumableOpts)}</span>
        <br />
        <span><strong>Clean up:</strong> {util.getLabel(data.clean_up, util.cleanUpOpts)}</span>
    </p>
    {/if}
</div>